module.exports = __webpack_public_path__ + "static/media/ic_mic.b9c25023.svg";